import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const BannerWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
`;

export const BannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const BannerText = styled.span`
  flex: 1;
`;

export const BannerLink = styled(Link)`
  color: inherit;
  text-decoration: underline;
  font-weight: 600;
  white-space: nowrap;

  &:hover {
    text-decoration: none;
  }
`;


